import Cookies from "js-cookie";

const cartData = (state = {}, action) => {
  let defaultData = {
    item: {},
    data: {},
    qty: 0,
    timestamp: null,
  };

  switch (action.type) {
    // ADD ITEM TO CART
    case "ADD_TO_CART":
      // ENSURE ACTION DOESN'T RUN TWICE
      // TODO: DETERMINE WHY IT'S BEING CALLED TWICE
      if (action.data.timestamp !== state.timestamp) {
        // FALLBACK QTY
        let qty = state.qty || defaultData.qty;

        // GET CURRENT CART COUNT FROM COOKIE IF AVAILABLE
        if (typeof Cookies.get("cartCount") !== "undefined") {
          qty = parseInt(Cookies.get("cartCount"), 10);
        }

        // UPDATE QTY
        if (action.data.qty) qty = action.data.qty + qty;
        // UPDATE COOKIE CART COUNT
        // if (action.data.env === 'development') Cookies.set('cartCount', qty);

        // RETURN UPDATED VALUES
        return Object.assign(defaultData, state, {
          item: action.data.item || state.item || defaultData.item,
          order: action.data.order,
          qty: qty,
          itemDeliveryType: action.data.itemDeliveryType,
          timestamp:
            action.data.timestamp || state.timestamp || defaultData.timestamp,
        });
      }

    // SHOW ADD TO CART MODAL
    case "SHOW_CART_MODAL":
      return Object.assign(defaultData, state, action.data);

    // HIDE ADD TO CART MODAL
    case "HIDE_CART_MODAL":
      return null;
  }

  return state;
};

export default cartData;
